import * as React from 'react';
import {
    FilterLiveSearch,
    NumberField,
    useLocale,
    // TextInput,
    useTranslate, SelectInput, TextField,
} from 'react-admin';

import {EditableDatagrid, RowForm} from "@react-admin/ra-editable-datagrid";
import ListComponentAdmin from "../../_common/ListComponentAdmin";
import TableActions from "../../_common/TableActions";
import useMyStyles from "../../utils/useMyStyles";
// import {universalTopFilters} from "../universalView/universalTopFilters";
// import {CardContent, useMediaQuery} from "@material-ui/core";
import {CardContent} from "@material-ui/core";
import CardComp from "../../_common/Asside/CardComp";
import {
    DateFieldComp,
    FilterDataAside,
    //NumberInputFloatComp,
    TextFieldBold
} from "../../_common/CompReact";
import {validateReq} from "../../_constants/validateTable";
import {choicesRole} from "../../_constants/choices";
import {MyTranslatableInputs} from "../../_common/MyTranslatableInputs";
import Box from "@mui/material/Box";

const universalTopFilters = (resource, locale) => {
    let dt = [];
    // dt.push(<TextInput label="Search" source="q" alwaysOn/>)
    // dt.push(<TextInput label="Brand" source="brand" defaultValue="Hello, World!"/>);
    return dt;
}

const UniversalAside = (props) => {
    //const {locale} = props;
    return (
        <CardComp id="aside_card">
            <CardContent>
                <FilterLiveSearch/>
                {/*<FilterDataAside fields={'created_at'} name={'create'}/>*/}
                <FilterDataAside fields={'updated'} name={'update'}/>
            </CardContent>
        </CardComp>
    )
};

const ListEditForm = (props) => {
    // const {classes, locale} = props;
    const {classes} = props;
    const translate = useTranslate();
    return (
        <RowForm {...props}>
            <NumberField source="id" headerClassName={classes.headerShortWidth}/>
            {/*<TextInput source={`name`} label={translate('Name ')} validate={validateFirstName} fullWidth/>*/}
            <Box flex={1}>
                <MyTranslatableInputs
                    isTranslate={false}
                    fullWidth
                    source={'name'}
                    label={translate('Name')}
                />
            </Box>
            <Box flex={1} mt={'8px'}>
                <SelectInput
                    variant={"outlined"}
                    source={'code'} choices={choicesRole}
                    label={translate('Role Type')} validate={validateReq} fullWidth
                />
            </Box>
            <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                           locale={'us'} cellClassName={classes.date_st}/>
        </RowForm>
    )
};

/*export const tableFilters = [
    <TextInput label="Search" source="q" alwaysOn/>,
    /!*<BooleanInput label="Only viewed" source="viewed" alwaysOff/>,*!/
];*/

export const Interfaces = props => {
    const classes = useMyStyles();
    const {resource} = props;

    // console.log('resource=============>', resource)
    // const {id} = record || {};
    const locale = useLocale();
    const translate = useTranslate();
    return (
        <ListComponentAdmin
            {...props}
            //hasCreate={true}
            style={{maxWidth: '120em'}}
            title={''}
            actions={<TableActions
                preference={`${resource}${".list.columns"}`}
                select={false}
                create={true}
                filter={true}
            />}
            // is_bulkActionButtons={false}
            filters={universalTopFilters(resource, locale)}
            sort={{field: 'id', order: 'DESC'}}
            aside={<UniversalAside locale={locale}/>}
        >
            <EditableDatagrid
                classes={{headerCell: classes.headerCell, row: classes.row, rowCell: classes.rowCell}}
                style={{maxWidth: '120em'}}
                //noDelete={true}
                // initialRowMode="edit"
                rowClick="edit"
                mutationMode="pessimistic" //Подтвердить удаление
                undoable
                createForm={<ListEditForm locale={locale} classes={classes} {...props} submitOnEnter={false}/>}
                editForm={<ListEditForm locale={locale} classes={classes} {...props} submitOnEnter={true}/>}
            >
                <NumberField source="id" headerClassName={classes.headerShortWidth}/>
                <TextField source={`name[${locale}]`} label={translate('Name')}/>
                <TextFieldBold source={`code`} label={translate('Code')}/>
                <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                               locale={'us'} cellClassName={classes.date_st}/>
            </EditableDatagrid>
        </ListComponentAdmin>
    )
};
